<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .panelbox
        .panel-holder
          .resbox
            .resbox-con
              .resbox-cusbox.dp.aaa
                .resbox-tabs
                  ul.nav.nav-tabs.s2(role='tablist')
                    li.nav-item(role='presentation' @click="changeTab(0)")
                      button#setProfile-tab.nav-link(:class="{'active' : selectedTab === 0}" data-bs-toggle='tab' data-bs-target='#setProfile' type='button' role='tab' aria-controls='setProfile' aria-selected='true')
                        img(src='/images/menu/a-profile.png')
                        span {{$t('ui.profile')}}
                    //- li.nav-item(role='presentation' @click="changeTab(4)")
                    li.nav-item(role='presentation' @click="$router.push('/statement').catch(err => {})")
                      button#setInbox-tab.nav-link(:class="{'active' : selectedTab === 4}" data-bs-toggle='tab' data-bs-target='#setInbox' type='button' role='tab' aria-controls='setInbox' aria-selected='true')
                        img(src='/images/menu/a-history.png')
                        span {{$t('ui.statement')}}
                    li.nav-item(role='presentation' @click="$router.push('/inbox').catch(err => {})")
                      button#setInbox-tab.nav-link(:class="{'active' : selectedTab === 4}" data-bs-toggle='tab' data-bs-target='#setInbox' type='button' role='tab' aria-controls='setInbox' aria-selected='true')
                        img(src='/images/menu/a-inbox.png')
                        span {{$t('ui.inbox')}}
                    li.nav-item(v-if="$store.getters.transaction.length === 0" role='presentation' @click="changeTab(3)")
                      button#setAddBank-tab.nav-link(:class="{'active' : selectedTab === 3}" data-bs-toggle='tab' data-bs-target='#setAddBank' type='button' role='tab' aria-controls='setAddBank' aria-selected='false')
                        img(src='/images/menu/a-bank.png')
                        span {{$t('ui.add_bank')}}
                    li.nav-item(v-if="$store.getters.transaction.length > 0" role='presentation' @click="changeTab(1)")
                      button#setBankDetail-tab.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#setBankDetail' type='button' role='tab' aria-controls='setBankDetail' aria-selected='false')
                        img(src='assets/img/bank/m-bank-d.png')
                        span  {{$t('ui.bank_detail')}}
                    li.nav-item(role='presentation' @click="changeTab(2)")
                      button#setChangePassword-tab.nav-link(:class="{'active' : selectedTab === 2}" data-bs-toggle='tab' data-bs-target='#setChangePassword' type='button' role='tab' aria-controls='setChangePassword' aria-selected='false')
                        img(src='/images/menu/a-password.png')
                        span {{$t('ui.change_password')}}
                  .tab-content
                    userProfile(v-if="selectedTab === 0")
                    bankProfile(v-if="selectedTab === 1" )
                    changePw(v-if="selectedTab === 2")
                    addBank(v-if="selectedTab === 3" @switchTab="switchTab")
                    inboxMenu(v-if="selectedTab === 4")
                    .logout-area.text-end.logout-mobile.statement-mob(v-if="isLoggedIn")
                      a.btn-logout.w-auto.mb-3(href='javascript:void(0)' @click="logout" style="background:transparent")
                        i.fa-solid.fa-arrow-right-from-bracket
                        | &nbsp;{{$t('ui.logout')}}
</template>
<script>
import userProfile from "@/components2/_profile.vue"
import addBank from '@/components2/_addBankDetails.vue'
import bankProfile from '@/components2/_bankDetails.vue'
import changePw from '@/components2/_changePassword.vue'
import inboxMenu from '@/views/default/_inboxMenu.vue'
export default {
	components:{
		userProfile,
		addBank,
		bankProfile,
		changePw,
    inboxMenu
	},
	data(){
		return{
			selectedTab: 0,
		}		
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    },
  },
	mounted(){
		window.scroll(0, 0)
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.option){
				this.selectedTab = this.$route.params.option
			}
      if(this.$route.params.addBank == true){
				this.selectedTab = 3
			}
      if(this.$route.params.inbox == true){
				this.selectedTab = 4
			}
    }
	},
	methods:{
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		switchTab(e){
			this.selectedTab = e
		},
    logout() {
      this.$store
        .dispatch("user/logout")
        .catch(err => {})
    },
	},
}
</script>